export default __webpack_public_path__ + "static/media/happy.1cf6bf64.svg";